<script>
export default {
	props: {
		currentClinic: Object,
		showModal: Boolean
	},
	data() {
		return {
			
		}
	},
	emits: ['close-modal'],
	methods: {
		urlIsValid(url) {
      return url !== null && url !== 'null' && url !== ''
    }
	}
}
</script>

<template>
	<!--modal-->
	<div :id="`clinic-${currentClinic.clinicId}`" tabindex="-1" aria-hidden="true" :class="{ 'hidden': !showModal }" class="overflow-y-auto overflow-x-hidden fixed top-0 right-0 left-0 z-50 justify-center items-center w-full md:inset-0 h-[calc(100%-1rem)] max-h-full">
		<div class="relative p-4 w-full max-w-4xl max-h-full">
			<!-- Modal content -->
			<div class="relative bg-white rounded-lg border border-gray-500 shadow">
				<!-- Modal header -->
				<div class="flex items-center justify-between p-4 md:p-5 border-b rounded-t">
					<h3 class="text-xl font-semibold">
						{{ currentClinic.clinicianName }} - {{ currentClinic.distanceStr }}
					</h3>
					<button @click="$emit('close-modal')" type="button" class="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center">
						<svg class="w-3 h-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14">
							<path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"/>
						</svg>
						<span class="sr-only">Close modal</span>
					</button>
				</div>
				<!-- Modal body -->
				<div class="p-4 md:p-5 space-y-4 rounded-b text-base leading-relaxed">
					<p v-if="currentClinic.completedPrograms" class="text-sm text-gray-700 mb-2">Graduate of {{ currentClinic.completedPrograms }}</p>
					<h3 class="text-2xl font-bold">{{ currentClinic.clinicianName }}, {{ currentClinic.credentials }} </h3>
					<h4 class="text-lg font-bold">{{ currentClinic.speciality }}</h4>
					<p v-if="currentClinic.coachingAvailable" class="mb-1"><i class="fas fa-award" aria-hidden="true"></i> <strong>AWCIM Certified Integrative Health Coach</strong></p>
					<p v-if="currentClinic.profession != 'N/A'" class="mb-1">{{ currentClinic.profession }}</p>
					<div class="flex flex-wrap">
						<div class="w-full md:w-1/3">
							<p v-if="currentClinic.telemedicine" class="text-sm mb-1"><i class="fas fa-user-md-chat" aria-hidden="true"></i> <strong>My practice offers telemedicine.</strong></p>
							<p v-if="currentClinic.acceptingNewPatients" class="text-sm mb-1"><i class="fa-regular fa-users-medical" aria-hidden="true"></i> <strong>My practice is accepting new patients.</strong></p>
							<p v-if="currentClinic.allowsInPersonVisits" class="text-sm mb-1"><i class="fa-regular fa-door-open" aria-hidden="true"></i> <strong>My practice offers in-person visits.</strong></p>
							<p v-if="currentClinic.acceptingReferrals" class="text-sm mb-1"><i class="fa-light fa-clipboard-user" aria-hidden="true"></i> <strong>My practice is accepting referrals.</strong></p>
							<p v-if="urlIsValid(currentClinic.url)" class="mb-1"><i class="fas fa-browser" aria-hidden="true"></i>&nbsp;<a :href="currentClinic.url" target="_blank" class="text-blue-800 underline">Visit Website</a></p>
							<p v-if="currentClinic.email" class="mb-1"><i class="fas fa-address-card" aria-hidden="true"></i>&nbsp;<a :href="`mailto:${currentClinic.email}`" class="text-blue-800 underline">{{ currentClinic.email }}</a></p>
							<p v-if="currentClinic.apptPhone" class="mb-1"><i class="fas fa-phone-square-alt" aria-hidden="true"></i>&nbsp;{{ currentClinic.apptPhone }}</p>
							<p v-if="currentClinic.address"><strong>Address</strong><br>{{ currentClinic.address }}</p>
						</div>
						<div class="w-full md:w-2/3">
							<h4 class="text-lg font-bold">{{ currentClinic.name }}</h4>
							<p v-html="currentClinic.listingText"></p>
							<p><strong>Payment Options:</strong> <br>
								<template v-if="currentClinic.payInsurance"><i class="fas fa-fw fa-shield" aria-hidden="true"></i> Insurance<br></template>
								<template v-if="currentClinic.payMedicare"><i class="fas fa-fw fa-landmark" aria-hidden="true"></i> Medicare<br></template>
								<template v-if="currentClinic.payDirect"><i class="fas fa-fw fa-money-bill-wave"></i> Direct<br></template>
								<template v-if="currentClinic.payOtherDetails"><i class="fas fa-fw fa-file-invoice-dollar"></i> {{ currentClinic.payOtherDetails }}<br></template>
							</p>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>